<template>
  <div class="p_s p_t">
    <TopHead title="确认支付"></TopHead>
    <div class="ps_c d_f j_c t_a">
        <div>
          <img src="../assets/img/ps_img.png" alt="">
          <div>支付成功</div>
          <div class="price">￥{{$route.query.totalPrice}}</div>
          <div class="d_f ali_c j_s btns">
            <div @click="$router.push('/')">返回首页</div>
            <div class="order" @click="$router.push('/OrderDetail?orderId='+$route.query.orderId)">查看订单</div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PaySuccess",
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  .ps_c{
    .btns{
      >div{
        &.order{
          background: #24BDDD;
          color: #ffffff;
        }
        font-size: 14px;
        font-weight: 500;
        color: #00ACD5;
        width: 87px;
        height: 30px;
        border: 1px solid #24BDDD;
        border-radius: 15px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content:center;
      }
      margin: 27px auto 0 auto;
      width: 205px;
    }
    .price{
      margin-top: 17px;
      font-size: 24px;
      font-weight: bold;
    }
    img{
      width: 99px;
      height: 60px;
      margin-bottom: 11px;
    }
    padding-top: 50px;
    box-sizing: border-box;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    color: #3E3E3E;
    background-color: #f5f5f5;
  }
</style>
